module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10197.754cebcd.jpg";